import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { MdOutlineCancelPresentation } from "react-icons/md";

import { placeTrade } from '../../database/actions/account';


import '../styles/trader.css'
const Trader = () => {
  const initialState = {
    amount: '',
    assetType: '',
    asset: '',
    stopLoss: '',
    action: '',
    duration: '',
  }

  const allAssets = [
    {
      "assetType": `Crypto Currency`,
      "assets": ["Bitcoin", "USDT", "ETH"]
    },
    {
      "assetType": `Commodity`,
      "assets": ["SPF", "TESLA", "Gold", "ETFS"]
    },
    {
      "assetType": `Currency`,
      "assets": ["USD/JPY", "GPB/USD", "AUD/USD", "USD/CAD", "EUR/JPY", "NZD/USD"]
    },
  ]

  const [formData, setFormData] = useState(initialState);
  const { account } = useSelector((state) => state.accounts);
  const [popUpgrade, setPopUpgrde] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const assetts = [...new Set(allAssets.map((data) => data.assetType))]
  const subAssets = allAssets.filter(
    (item) => item.assetType === formData?.assetType
  );
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const buyTrade = (e) => {
    let formDetails = {
      "amount": `${formData?.amount}`,
      "type": `Manual`,
      "assetType": `${formData?.assetType}`,
      "assets": `${formData?.asset}`,
      "stopLoss": `${formData?.stopLoss}`,
      "action": `Buy`,
      "duration": `${formData?.duration}`,
    }
    dispatch(placeTrade(account?._id, formDetails, navigate, account));
  }

  const sellTrade = (e) => {
    let formDetails = {
      "amount": `${formData?.amount}`,
      "type": `Manual`,
      "assetType": `${formData?.assetType}`,
      "assets": `${formData?.asset}`,
      "stopLoss": `${formData?.stopLoss}`,
      "action": `Sell`,
      "duration": `${formData?.duration}`,
    }
    dispatch(placeTrade(account?._id, formDetails, navigate, account));
  }

  return (
    <>
      <div className="trader">
        <div className="header">
          <h3>Manual Trader</h3>
        </div>
        <div className="tradeForm">
          <form action="#">
            <div className="form-cont">
              <input type="number" name="amount" id="amount" onChange={handleChange} required />
              <div className="underline"></div>
              <label htmlFor="amount">Amount</label>
            </div>
            <div className="form-cont">
              <select name='assetType' id='assetType' onChange={handleChange} required>
                <option value=''>Select Asset Type</option>
                {
                  assetts.map((country, index) => (
                    <option value={country} key={index}>{country}</option>
                  ))
                }
              </select>
            </div>
            <div className="form-cont">
              <select name='asset' id='asset' onChange={handleChange} required>
                <option value=''>Select Asset</option>
                {
                  subAssets[0]?.assets?.map((country, index) => (
                    <option value={country} key={index}>{country}</option>
                  ))
                }
              </select>
            </div>
            <div className="form-cont">
              <select name='stopLoss' id='stopLoss' onChange={handleChange} required>
                <option value=''>Set stop loss</option>
                <option value={`5%`}>5%</option>
                <option value={`15%`}>15%</option>
                <option value={`25%`}>25%</option>
                <option value={`35%`}>35%</option>
                <option value={`50%`}>50%</option>
              </select>
            </div>
            <div className="form-cont">
              <p>Duration: </p>
              <input type="datetime-local" placeholder='local date' name="duration" id="duration" onChange={handleChange} required />
            </div>
            <div className="btns">
              {
                account?.level === "Basic" ?
                  <>
                    <h3 onClick={(e) => setPopUpgrde(true)}>BUY</h3>
                    <h3 className='sll' onClick={(e) => setPopUpgrde(true)}>SELL</h3>
                  </> :
                  <>
                    <h3 onClick={(e) => buyTrade()}>BUY</h3>
                    <h3 className='sll' onClick={(e) => sellTrade()}>SELL</h3>
                  </>
              }
            </div>
          </form>
        </div>
        {
          popUpgrade &&
          <div className="upgrade">
            <div className="cont">
              <h3>Upgrade Required</h3>
              <p>Your account Level is currently on <span>Basic</span>. You'll need to upgrade your account to use this feature. If you're not verified yet, you'll need to verify account to use certain features.</p>
              <h5>Contact admin via livechat or through one of the verified channels.</h5>
              <div className="cancel" onClick={(e) => setPopUpgrde(false)}>
                <MdOutlineCancelPresentation />
              </div>
            </div>
          </div>
        }
      </div>
    </>
  )
}

export default Trader